import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import Footer from './Footer'

const ForgetPassword = () => {
  const [showOtp, setShowOtp] = useState(false)
  const [showEmail, setShowEmail] = useState(true)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [userId, setUserId] = useState(null)
  const navigate = useNavigate()

  const BASE_URl = window.location.origin

  const handleForgetPasswod = (e) =>{
    e.preventDefault()
    const formData = {
      email: e.target.email.value
    }

    fetch(`${BASE_URl}/api/forgetPassword`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then((res) => res.json())
    .then((data) => {
      if(data&&data.sucess === true){
        toast.success(data.messege)
        setShowEmail(!showEmail)
        setShowOtp(!showOtp)
      } else if(data&& data.sucess === false){
        toast.error(data.messege)
      }
    })
    .catch((error) => {
      if(error) {
        toast.error(error.messege || 'Something went wrong')
      }
    })

    e.target.reset()
  }

  const handleSendOtp = (e) => {
    e.preventDefault()
    const formData = {
      otp: e.target.otp.value
    }
    fetch(`${BASE_URl}/api/forgetPassword`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then((res) => res.json())
    .then((data) => {
      if(data.sucess === true){
        setUserId(data.userId)
        setShowNewPassword(!showNewPassword)
        setShowOtp(!showOtp)
        toast.success(data.messege)
      } else if(data.sucess === false){
        
        toast.error(data.messege)
      }
    })
    .catch((error) => {
      if(error) {
        toast.error('Something Went Wrong')
      }
    })

    e.target.reset()
  }

  const handleSendNewPassword = (e) => {
    e.preventDefault()
    const formData = {
      password: e.target.password.value
    }
    fetch(`${BASE_URl}/api/newPassword/${userId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then((res) => res.json())
    .then((data) => {
      if(data&&data.sucess === true){
        toast.success(data.messege)
        navigate('/auth/login')
      } else if(data&&data.sucess === false){
        
        toast.error(data.messege)
      }
    })
    .catch((error) => {
      console.log(error)
      if(error) {
        toast.error('Something Went Wrong')
      }
    })

    e.target.reset()
  }
  
  return (
    <>
    <div className='mt-24 flex flex-col items-center h-[80vh] '>
    <h1 className='text-center mb-8 text-3xl font-serif '>Enter Your Email</h1>
    <div className='flex flex-col gap-6 bg-blue-300 p-3 h-fit pt-10 pb-10 rounded-[10px] sm:w-[80%] lg:w-[70%]'>
    {showEmail?<form onSubmit={handleForgetPasswod} className='flex justify-center w-[90%] gap-2'>
      <input required type="email" placeholder='Your Email' name="email" className=' border-[0.5px] p-3 outline-0 rounded-[8px] w-[60%] active:bg-none placeholder:text-black'/>
        <button type='submit' className='cursor-pointer border-[0.5px] p-3 rounded-2xl bg-blue-200 hover:bg-blue-300' style={{transition: '0.5s'}}>Next</button>
    </form>:null}


    {showOtp?<form onSubmit={handleSendOtp} className='flex justify-center w-[90%] gap-2'>
      <input required type="text" maxLength={6} placeholder='Enter OTP' name="otp" className=' border-[0.5px] p-3 outline-0 rounded-[8px] w-[60%] active:bg-none placeholder:text-black'/>
        <button type='submit' className='cursor-pointer border-[0.5px] p-3 rounded-2xl bg-blue-200 hover:bg-blue-300' style={{transition: '0.5s'}}>Next</button>
    </form>:null}


    {showNewPassword?<form onSubmit={handleSendNewPassword} className='flex justify-center w-[90%] gap-2'>
      <input required type="text" placeholder='New Password' name="password" className=' border-[0.5px] p-3 outline-0 rounded-[8px] w-[60%] active:bg-none placeholder:text-black'/>
        <button type='submit' className='cursor-pointer border-[0.5px] p-3 rounded-2xl bg-blue-200 hover:bg-blue-300' style={{transition: '0.5s'}}>Next</button>
    </form>:null}
    </div>
  </div>
    <Footer/>
    </>

  )
}

export default ForgetPassword
